import React, { useState, useEffect } from "react";
import instance, { lienImage } from "../../api/api";
import { Help } from "../../utils";
import { ProgressSpinner } from "primereact/progressspinner";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import { Image } from "primereact/image";
const handleStatut = {
  "en attente": "gray",
  refuser: "red",
  accepter: "green",
};
function ReclamationDetails() {
  const navigate = useNavigate();
  const { id, type } = useParams();

  const MySwal = withReactContent(Swal);

  const [dataDetail, setDataDetail] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isCommande, setIsCommande] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleAccepte, setVisibleAccepte] = useState(false);
  //   const [dateLivraison, setDateLivraison] = useState("");
  const [dataCommentaire, setDataCommentaire] = useState("");
  async function handleColi(value) {
    setIsCommande(true);
    const data = {
      statut: value,
      commentaire: dataCommentaire,
    };
    console.log("DATA", data);
    try {
      const response = await instance.put(
        `/reclamations/${dataDetail.id}`,
        data
      );
      console.log("response", response.data);
      dataDetail.statut = value;
      dataDetail.commentaire = dataCommentaire;
      console.log("dataDetail.statut", dataDetail.statut);
      if (response.data.status === true) {
        MySwal.fire({
          title: "confirmation reussie",
          icon: "info",
          showConfirmButton: true,
        });
        setVisible(false);
        setIsCommande(false);
        setVisibleAccepte(false);
      }
    } catch (error) {
      console.log(error);
      setIsCommande(false);
      setVisibleAccepte(false);
    }
  }
  const accepterCommande = () => {
    console.log("accepterCommande");
    handleColi("accepter");
  };
  const annulerColis = () => {
    console.log("annulee");
    handleColi("refuser");
  };
  const sendColis = (value) => {
    switch (value) {
      case "accepter":
        accepterCommande();
        break;
      case "annuler":
        annulerColis();
        break;
      default:
        console.log("send");
        break;
    }
  };

  useEffect(() => {
    const getReclamationDetails = async () => {
      setIsLoading(true);
      try {
        const response = await instance.get(`/reclamations/${id}`);
        console.log(response);
        setDataDetail(response.data.data);
        setIsLoading(false);
      } catch (error) {
        console.error("Une erreur s'est produite : ", error);
        setIsLoading(false);
      }
    };
    getReclamationDetails();
  }, [id]);

  if (isLoading)
    return (
      <div className="create-user">
        <h1 className="text-center">Chargement...</h1>
      </div>
    );
  return (
    <div className="create-user">
      <Dialog
        header="Êtes-vous sûr(e) de vouloir valider cette réclamation ?"
        visible={visibleAccepte}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!visibleAccepte) return;
          setVisibleAccepte(false);
        }}
      >
        <textarea
          name=""
          id=""
          cols="30"
          rows="10"
          className="w-100"
          onChange={(e) => setDataCommentaire(e.target.value)}
        ></textarea>
        <button
          className="btn bg-success mx-2 text-light"
          onClick={() => sendColis("accepter")}
        >
          {!isCommande ? (
            "Valider"
          ) : (
            <ProgressSpinner
              style={{ width: "25px", height: "25px" }}
              strokeWidth="5"
              animationDuration=".5s"
            />
          )}
        </button>
      </Dialog>
      <Dialog
        header="Commentaire"
        visible={visible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!visible) return;
          setVisible(false);
        }}
      >
        <textarea
          name=""
          id=""
          cols="30"
          rows="10"
          className="w-100"
          onChange={(e) => setDataCommentaire(e.target.value)}
        ></textarea>
        <button
          className="btn bg-danger mx-2 text-light"
          onClick={() => sendColis("annuler")}
        >
          {!isCommande ? (
            "Confirmer"
          ) : (
            <ProgressSpinner
              style={{ width: "25px", height: "25px" }}
              strokeWidth="5"
              animationDuration=".5s"
            />
          )}
        </button>
      </Dialog>
      <span
        onClick={() => navigate("/reclamations/commandes")}
        style={{ cursor: "pointer" }}
      >
        <FaArrowLeft fontSize={"2em"} />
      </span>
      <h3 className="my-4 text-center">Détail {type}</h3>
      {dataDetail && (
        <div>
          <h5 className="text-end my-3">
            <span className="text-secondary">Statut :</span>
            <span
              style={{
                background: handleStatut[dataDetail.statut],
                padding: ".3em",
                color: "white",
              }}
            >
              {dataDetail.statut}
            </span>
          </h5>
          <h5>
            <span className="text-secondary">Date d'enregistrement : </span>{" "}
            {new Date(dataDetail.created_at).toLocaleDateString("fr")}
          </h5>
          <h6 className="badge bg-primary">Détail de commande</h6>
          <h5>
            <span className="text-secondary">Commande passée le : </span>{" "}
            {dataDetail.commande.date_commande}
          </h5>
          <h5>
            <span className="text-secondary">Commande livrée le : </span>{" "}
            {dataDetail.commande.date_livraison}
          </h5>
          <h5>
            <span className="text-secondary">référence : </span>{" "}
            {dataDetail.commande.reference}
          </h5>
          <h5>
            <span className="text-secondary">Montant versé : </span>{" "}
            {Help.convertInMoney(dataDetail.commande.total)} Fcfa
          </h5>

          <h6 className="badge bg-warning">Infos du client</h6>
          <h5>
            <span className="text-secondary">Nom & prénoms : </span>{" "}
            {dataDetail.user.nom} {dataDetail.user.prenom}
          </h5>
          <h5>
            <span className="text-secondary">Contact : </span>{" "}
            {dataDetail.user.phone}
          </h5>
          <h5>
            <span className="text-secondary">email : </span>{" "}
            {dataDetail.user.email}
          </h5>
          {dataDetail.commentaire_client && (
            <h5>
              <span className="text-secondary">Commentaire du client : </span>{" "}
              {dataDetail.commentaire_client}
            </h5>
          )}

          <h6 className="badge bg-secondary">Photos</h6>
          <div className="d-flex align-items-center gap-1 mb-5 flex-wrap">
            {dataDetail.photos.map((item) => (
              <div className="contenueur-image_produit" key={item.id}>
                <Image src={lienImage ? lienImage:null + item.path} alt={item.path} preview />
                {/* <img src={lienImage + item.path} alt={item.path} /> */}
              </div>
            ))}
          </div>
          {dataDetail.commentaire && (
            <h5>
              <span className="text-secondary">
                Commentaire du gestionnaire :{" "}
              </span>{" "}
              {dataDetail.commentaire}
            </h5>
          )}

          {dataDetail.statut === "en attente" && (
            <>
              <div className="text-center">
                <button
                  onClick={() => setVisibleAccepte(true)}
                  className="btn-lg bg-success text-light rounded border-0 p-2 mx-3"
                >
                  Accepter
                </button>
                <button
                  className="btn-lg bg-danger text-light border-0 rounded p-2"
                  onClick={() => setVisible(true)}
                >
                  Refuser
                </button>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default ReclamationDetails;
